import React, { createContext, useState } from "react";
import { captionToHtmlIfNeeded } from "src/components/RichTextEditor/htmlToCaption";

export const FormDataContext = createContext();

/**
 * Provider component that wraps the app where form data is needed.
 * It holds the state and provides it to all child components via context.
 */

export const FormDataProvider = ({ quote, children }) => {

    const [formData, setFormData] = useState(
        quote ?
            {
                ...quote,
                article: {
                    ...(quote.article || {}),
                    articleHtml: captionToHtmlIfNeeded(quote.article?.articleHtml || "")
                },
                customization: {
                    ...(quote.customization || {}),
                },
                objectImage: {
                    quotes: quote.imageUrl || null,
                    article: quote.article?.imageUrl || null
                }
            } : {
                uuid: "",
                imageUrl: null,
                quoteText: "",
                author: "",
                companyUuid: "",
                categories: [],
                specialDate: "",
                thumbnailUrl: null,
                quotePool: 3,
                isFreeContent: false,
                quoteTypes: null,
                dayOfWeek: "",

                article: {
                    title: "",
                    imageUrl: null,
                    articleHtml: "",
                    referenceLinks: [],
                },

                customization: {
                    textColor: "#fff",
                    fontSize: 20,
                    textAlign: "center",
                    textFont: "Manrope",
                    verticalAlign: "center",
                },
                // For ui display and updates
                objectImage: {
                    article: null,
                    quotes: null,
                }
            }
    );

    return (
        <FormDataContext.Provider value={{ formData, setFormData }}>
            {children}
        </FormDataContext.Provider>
    );
};
